import { PostMessage } from '../Shared/PostMessage';

export const InitializePresenceInformationId: string = 'ComponentPresence_initialize';
export const PresenceChangedId: string = 'ComponentPresence_presenceChanged';

export interface InitializePresenceInformationMessage extends PostMessage<typeof InitializePresenceInformationId> {
  payload: { presenceInformation: ComponentPresenceInformation };
}

export interface PresenceChangedMessage extends PostMessage<typeof PresenceChangedId> {
  payload: { clientId: string; presence: PresenceSelectionProps | undefined };
}

/* From @fluidx/office-fluid-types */

export interface PresenceSelectionProps {
  [name: string]: string | number | boolean | undefined;
}

/**
 * A map keeps a components' client information
 * Map's key is clientId, value is the data representing presence of such client in a given component
 */
export type ComponentPresenceInformation = { [clientId: string]: PresenceSelectionProps | undefined };
